// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#main-app-bar[data-v-11da4968]{background:linear-gradient(90deg,#04b1e0,#33bade,#647ec2,#4d68ad)!important}.v-main[data-v-11da4968]{background-color:#d2dfe8}.logo[data-v-11da4968]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
